import React, { RefObject } from 'react'

export type Size = {
  width: number
  height: number
  isMobile: boolean
}

function isMobile() {
  return window.innerWidth < 600
}

function getSize(el: any) {
  const bbox = el.getBoundingClientRect()
  return {
    width: bbox.width,
    height: bbox.height,
    // TODO: upgrade and use ta-browserCheck?
    isMobile: isMobile(),
  }
}

export function useSize(): [RefObject<HTMLDivElement>, Size] {
  const container = React.useRef(null)
  const [size, setSize] = React.useState<Size>({
    width: 0,
    height: 0,
    isMobile: true,
  })
  const handleResize = React.useCallback(
    function handleResize() {
      if (container.current !== null) {
        setSize(getSize(container.current))
      }
    },
    [container]
  )
  const dependencyArray = isMobile() ? [] : [container, handleResize]
  React.useLayoutEffect(() => {
    handleResize()
    window.addEventListener('resize', handleResize)
    return function () {
      window.removeEventListener('resize', handleResize)
    }
  }, dependencyArray)

  return [container, size]
}

export default useSize
